<template>
  <Modal
    v-model="_value"
    width="500"
    title="锐明设置协议"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Tabs value="Checkbox" type="card" >
      <TabPane label="选择通道" name="Checkbox">
        <Form ref="setDriverParamsRef" v-model="setDriverParams" :label-width="90">
          <FormItem prop="possword" label="密码">
            <Button type="primary" @click="possworsOne" style="margin-right: 5px;">密码1</Button>
            <Button type="primary" @click="posswordTwo">密码2</Button>
            <Input v-model="setDriverParams.possword" type="password" password placeholder="请输入密码">
            </Input>
          </FormItem>
          <!--          <FormItem prop="CC" label="客户代码">-->
          <!--            <Input v-model="setDriverParams.CC" placeholder="请输入客户代码">-->
          <!--            </Input>-->
          <!--          </FormItem>-->
          <!--          <FormItem prop="NBB" label="协议版本">-->
          <!--            &lt;!&ndash;        <Input v-model="setDriverParams.NBB" placeholder="请输入协议版本">&ndash;&gt;-->
          <!--            &lt;!&ndash;        </Input>&ndash;&gt;-->

          <!--            <Select v-model="setDriverParams.NBB">-->
          <!--              <Option v-for="item in NBBOptions" :value="item.value" :key="item.value">{{item.label}}</Option>-->
          <!--            </Select>-->

          <!--          </FormItem>-->
          <!--      <FormItem prop="driverLicenseNum" label="从业资格证号">-->
          <!--      <FormItem prop="driverLicenseNum" label="司机卡号">-->
          <!--        <Input v-model="setDriverParams.qualificationCode" placeholder="请输入司机卡号">-->
          <!--        </Input>-->
          <!--      </FormItem>-->
          <!--      <FormItem prop="driverLicenseNum" label="发证机构名称">-->
          <!--        <Input v-model="setDriverParams.organizationNames" placeholder="请输入发证机构名称">-->
          <!--        </Input>-->
          <!--      </FormItem>-->
          <!--      <FormItem prop="driverLicenseNum" label="证件有效期">-->
          <!--        <Input v-model="setDriverParams.indate" placeholder="请输入证件有效期">-->
          <!--        </Input>-->
          <!--      </FormItem>-->

          <FormItem prop="NBB" label="通道">
            <CheckboxGroup v-model="setDriverParams.Checkbox">
              <Checkbox label="1"></Checkbox>
              <Checkbox label="2"></Checkbox>
              <Checkbox label="3"></Checkbox>
              <Checkbox label="4"></Checkbox>
              <Checkbox label="5"></Checkbox>
              <Checkbox label="6"></Checkbox>
            </CheckboxGroup>
          </FormItem>

<!--          <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>-->
<!--          <Button type="primary" @click="onSendDriverCardParams">确认</Button>-->
        </Form>
      </TabPane>

      <template v-for="(item, index) in setDriverParams.Checkbox">

        <TabPane :index="index" v-if="item == 1" label="通道1" name="access1" style="height: 350px;">
          <Form ref="setDriverParamsRef" v-model="setDriverParams.PI[0]" :label-width="90">

            <FormItem prop="CC" label="客户代码">
              <Input v-model="setDriverParams.PI[0].CC" placeholder="请输入客户代码" style="width: 300px;">
              </Input>
            </FormItem>
            <FormItem prop="NBB" label="协议版本">
              <Select v-model="setDriverParams.PI[0].GPS.NBB" style="width: 300px;">
                <Option v-for="item in NBBOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
            <FormItem prop="CS.UDM" label="报警上传选项">
              <Select v-model="setDriverParams.PI[0].CS.UDM" style="width: 300px;">
                <Option v-for="item in UATCHOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
            <FormItem prop="CS.UATCH" label="附件上传选项">
              <Select v-model="setDriverParams.PI[0].CS.UATCH" style="width: 300px;">
                <Option v-for="item in UATCHOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>


          </Form>
        </TabPane>
        <TabPane :index="index" v-if="item == 2"  label="通道2" name="access2" style="height: 350px;">
          <Form ref="setDriverParamsRef" v-model="setDriverParams.PI[1]" :label-width="90">

            <FormItem prop="CC" label="客户代码">
              <Input v-model="setDriverParams.PI[1].CC" placeholder="请输入客户代码" style="width: 300px;">
              </Input>
            </FormItem>
            <FormItem prop="NBB" label="协议版本">
              <Select v-model="setDriverParams.PI[1].GPS.NBB" style="width: 300px;">
                <Option v-for="item in NBBOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
            <FormItem prop="CS.UDM" label="报警上传选项">
              <Select v-model="setDriverParams.PI[1].CS.UDM" style="width: 300px;">
                <Option v-for="item in UATCHOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
            <FormItem prop="CS.UATCH" label="附件上传选项">
              <Select v-model="setDriverParams.PI[1].CS.UATCH" style="width: 300px;">
                <Option v-for="item in UATCHOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Form>
        </TabPane>
        <TabPane :index="index" v-if="item == 3"  label="通道3" name="access3" style="height: 350px;">
          <Form ref="setDriverParamsRef" v-model="setDriverParams.PI[2]" :label-width="90">

            <FormItem prop="CC" label="客户代码">
              <Input v-model="setDriverParams.PI[2].CC" placeholder="请输入客户代码" style="width: 300px;">
              </Input>
            </FormItem>
            <FormItem prop="NBB" label="协议版本">
              <Select v-model="setDriverParams.PI[2].GPS.NBB" style="width: 300px;">
                <Option v-for="item in NBBOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
            <FormItem prop="CS.UDM" label="报警上传选项">
              <Select v-model="setDriverParams.PI[2].CS.UDM" style="width: 300px;">
                <Option v-for="item in UATCHOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
            <FormItem prop="CS.UATCH" label="附件上传选项">
              <Select v-model="setDriverParams.PI[2].CS.UATCH" style="width: 300px;">
                <Option v-for="item in UATCHOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Form>
        </TabPane>
        <TabPane :index="index" v-if="item == 4"  label="通道4" name="access4" style="height: 350px;">
          <Form ref="setDriverParamsRef" v-model="setDriverParams.PI[3]" :label-width="90">

            <FormItem prop="CC" label="客户代码">
              <Input v-model="setDriverParams.PI[3].CC" placeholder="请输入客户代码" style="width: 300px;">
              </Input>
            </FormItem>
            <FormItem prop="NBB" label="协议版本">
              <Select v-model="setDriverParams.PI[3].GPS.NBB" style="width: 300px;">
                <Option v-for="item in NBBOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
            <FormItem prop="CS.UDM" label="报警上传选项">
              <Select v-model="setDriverParams.PI[3].CS.UDM" style="width: 300px;">
                <Option v-for="item in UATCHOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
            <FormItem prop="CS.UATCH" label="附件上传选项">
              <Select v-model="setDriverParams.PI[3].CS.UATCH" style="width: 300px;">
                <Option v-for="item in UATCHOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>

          </Form>
        </TabPane>
        <TabPane :index="index" v-if="item == 5"  label="通道5" name="access5" style="height: 350px;">
          <Form ref="setDriverParamsRef" v-model="setDriverParams.PI[4]" :label-width="90">

            <FormItem prop="CC" label="客户代码">
              <Input v-model="setDriverParams.PI[4].CC" placeholder="请输入客户代码" style="width: 300px;">
              </Input>
            </FormItem>
            <FormItem prop="NBB" label="协议版本">
              <Select v-model="setDriverParams.PI[4].GPS.NBB" style="width: 300px;">
                <Option v-for="item in NBBOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
            <FormItem prop="CS.UDM" label="报警上传选项">
              <Select v-model="setDriverParams.PI[4].CS.UDM" style="width: 300px;">
                <Option v-for="item in UATCHOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
            <FormItem prop="CS.UATCH" label="附件上传选项">
              <Select v-model="setDriverParams.PI[4].CS.UATCH" style="width: 300px;">
                <Option v-for="item in UATCHOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>

          </Form>
        </TabPane>
        <TabPane :index="index" v-if="item == 6"  label="通道6" name="access6" style="height: 350px;">
          <Form ref="setDriverParamsRef" v-model="setDriverParams.PI[5]" :label-width="90">

            <FormItem prop="CC" label="客户代码">
              <Input v-model="setDriverParams.PI[5].CC" placeholder="请输入客户代码" style="width: 300px;">
              </Input>
            </FormItem>
            <FormItem prop="NBB" label="协议版本">
              <Select v-model="setDriverParams.PI[5].GPS.NBB" style="width: 300px;">
                <Option v-for="item in NBBOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
            <FormItem prop="CS.UDM" label="报警上传选项">
              <Select v-model="setDriverParams.PI[5].CS.UDM" style="width: 300px;">
                <Option v-for="item in UATCHOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
            <FormItem prop="CS.UATCH" label="附件上传选项">
              <Select v-model="setDriverParams.PI[5].CS.UATCH" style="width: 300px;">
                <Option v-for="item in UATCHOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>

          </Form>
        </TabPane>

      </template>

    </Tabs>
    <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
    <Button type="primary" @click="onSendDriverCardParams">确认</Button>
  </Modal>
</template>

<script>

  import Vue from 'vue'
  import { mapActions } from 'vuex'
  import store from '@/store'
  import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

  import MaintainOrderAddMaintainDeviceRecordModal from '@/view/om/components/maintain-order-add-maintain-device-record-modal'

  export default {
    name: 'rmdrivermodal',
    components: {

    },
    props: {
      initValue: null,
      terminalNumValue: null,
      value: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        setDriverParams: {
          id: null,
          possword: 'admin',
          qualificationCode: null,
          organizationNames: null,
          indate: null,
          Checkbox:[],
          PI:[
            {CC:null,GPS:{NBB:null},CS:{UATCH:null,UDM:null}},
            {CC:null,GPS:{NBB:null},CS:{UATCH:null,UDM:null}},
            {CC:null,GPS:{NBB:null},CS:{UATCH:null,UDM:null}},
            {CC:null,GPS:{NBB:null},CS:{UATCH:null,UDM:null}},
            {CC:null,GPS:{NBB:null},CS:{UATCH:null,UDM:null}},
            {CC:null,GPS:{NBB:null},CS:{UATCH:null,UDM:null}}
          ]
        },

        JSON:['null','null','null','null','null','null'],

        NBBOptions: [
          {label: '2013协议', value: '0'},
          {label: '2019协议', value: '1'}
        ],

        UATCHOptions:[
          {label: '上传一二级', value: 0},
          {label: '只上传一级', value: 1},
          {label: '只上传二级', value: 2},
          {label: '都不上传', value: 3},
        ]
      }
    },
    methods: {
      ...mapActions([
        'VehicleInfoServ_SearchByName'
      ]),
      visibleChange (val) {
        if (val) {
          this.setDriverParams.id = this._initValue
          this.setDriverParams.qualificationCode = null
          this.setDriverParams.organizationNames = null
          this.setDriverParams.indate = null
          this.possworsOne()
        }
      },
      onCleanDriverCardParams () {
        this.setDriverParams.possword = 'admin'
        this.setDriverParams.qualificationCode = null
        this.setDriverParams.organizationNames = null
        this.setDriverParams.indate = null
      },
      onSendDriverCardParams () {
        // if (this.setDriverParams.CC == null){
        //   this.$Message.error("请输入客户代码")
        // }
        // if (this.setDriverParams.NBB == null){
        //   this.$Message.error("请选择协议版本")
        // }
        // if (this.setDriverParams.NBB != null) {
        //   this.setDriverParams.qualificationCode = this.setDriverParams.NBB
        // }

        console.log(this.setDriverParams)
        for (let i = 0; i < this.setDriverParams.Checkbox.length; i++) {
        console.log(this.JSON)
        console.log(this.setDriverParams.Checkbox[i])
        console.log(this.setDriverParams.PI[this.setDriverParams.Checkbox[i]-1])
        console.log(JSON.stringify(this.JSON[this.setDriverParams.Checkbox[i]-1]))
          this.JSON[this.setDriverParams.Checkbox[i]-1] = JSON.stringify(this.setDriverParams.PI[this.setDriverParams.Checkbox[i]-1])
        console.log(this.JSON[this.setDriverParams.Checkbox[i]-1])
        }

        //99admin,admin,JSON,{"PSI":{"PI":[null,null,null,{"CC":"54","GPS":{"NBB":"0"}},null,null]}}!
        console.log('99admin,' + this.setDriverParams.possword + ',JSON,{"PSI":{"PI":[' + this.JSON + ']}}!')
        let content = '99admin,' + this.setDriverParams.possword + ',JSON,{"PSI":{"PI":[' + this.JSON + ']}}!'
        let batchSendCmd = {cmd:null,urgent:false}
        batchSendCmd.cmd = content
        batchSendCmd.urgent = false
        // console.log(batchSendCmd)
        this.$emit('RM_Driver',batchSendCmd)


        // store.dispatch('NetCommandServ_SendCommand', {
        //   params: { id: this._initValue, content:content, urgent: false }
        // }).then(() => {
        //   this.$Message.success('发送成功')
        //   this.JSON = ['null','null','null','null','null','null']
        // }).catch(err => {
        //   this.$Message.error(err)
        //   this.JSON = ['null','null','null','null','null','null']
        // })
      },
      possworsOne(){
        this.setDriverParams.possword = 'admin'
      },
      posswordTwo(){
        this.setDriverParams.possword = 'JC336699'
      },
    },
    computed: {
      _value: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get () {
          return this.initValue
        },
        set (val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _terminalNumValue: {
        get () {
          return this.terminalNumValue
        },
        set (val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted () {
      this.$nextTick(() => {

      })
    }
  }
</script>
